exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".asset-preview[data-v-dba37ac2]{border:2px solid #e4e4e4;border-radius:.35rem}.asset-preview.in-selection[data-v-dba37ac2]{border-color:#ced4da}.asset-preview .thumbnail[data-v-dba37ac2]{padding:0;height:198px}.asset-preview .thumbnail img[data-v-dba37ac2]{max-width:100%}.asset-preview.in-selection .thumbnail[data-v-dba37ac2]{height:128px}.asset-preview.in-selection .thumbnail img[data-v-dba37ac2]{max-height:128px}.asset-preview:hover .card-body .asset-info.stay[data-v-dba37ac2]{opacity:1}", ""]);

// exports
